import { ChangeDetectionStrategy, Component, computed, effect, input } from '@angular/core';
import { MdsIconButtonComponent } from '@medpacesoftwaredevelopment/designsystem';
import { NoteCardContext } from './note-card-context.enum';
import { NoteCardElementFormGroup, NoteCardFormGroup } from './note-card.formgroup';
import { NoteCardElement } from './note.model';
import { RequestSideNotesItemComponent } from './request-side-notes-item/request-side-notes-item.component';

@Component({
    selector: 'medpace-request-side-notes',
    imports: [RequestSideNotesItemComponent, MdsIconButtonComponent],
    templateUrl: './request-side-notes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestSideNotesComponent {
    context = input<NoteCardContext | null>(null);
    contextValues = NoteCardContext;
    objectId = input<number>();

    simplifiedContext = computed(() => {
        if (!this.context()) return null;

        if (this.isRequestContext()) return 'Request';

        const value = this.context()!;
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    });

    isRequestContext = computed(() => {
        return (
            this.context() === NoteCardContext.Reimbursement ||
            this.context() === NoteCardContext.Travel ||
            this.context() === NoteCardContext.Stipend
        );
    });

    formGroup = new NoteCardFormGroup();

    notes = input<NoteCardElement[]>([]);

    notesLoaded = effect(() => {
        if (!this.notes()) return;
        this.formGroup.setValueFromModel(this.notes());
    });

    title = computed(() => {
        if (!this.simplifiedContext()) return 'Notes';

        return this.simplifiedContext() + ' Notes';
    });

    hasNewNote(): boolean {
        return this.formGroup.controls.notes.controls.some((control) => control.getModelFromValue().id === 0);
    }

    addNote(): void {
        if (this.hasNewNote()) return;

        const control = new NoteCardElementFormGroup({ id: 0, note: '', modifiedInitials: null, modifiedTime: null });
        this.formGroup.controls.notes.push(control);
    }

    handleRemoveNote(noteId: number): void {
        const index = this.formGroup.controls.notes.controls.findIndex(
            (control) => control.getModelFromValue().id === noteId
        );

        if (index === -1) return;

        this.formGroup.controls.notes.removeAt(index);
    }
}
